import { useTranslationContext } from "@providers/TranslationProvider";
import Image from "@components/Image";
import Link from "@components/Link";
import Button from "@components/Button";
import cx from "classnames";
import _ from "lodash";
import { useRouteContext } from "@providers/RouteProvider";

const View = ({
  topic,
  date,
  title,
  description,
  src,
  slug,
  image,
  className,
}: any) => {
  const { i18n } = useTranslationContext();
  const { router } = useRouteContext();

  return (
    <Link
      href={router.toUrl("storiesArticle", { slug })}
      className={cx("ama-post vertical", className)}
    >
      <div className="head">
        <div className="label">{i18n.t(topic)}</div>
        <div className="date">{date}</div>
      </div>
      <Image
        wrapperProps={{ className: "" }}
        className="img fit"
        src={_.get(image, "src", "") ?? src}
        alt={_.get(image, "alt", "") ?? title}
        layout="fill"
        objectFit="cover"
      />
      <div className="title">{title}</div>
      <div className="description text-ellipsis-4">{description}</div>
      <Button
        type="icon"
        className="uppercase button"
        label={i18n.t("Button.moreDetail")}
        suffix="shape-arrow"
      />
    </Link>
  );
};
export default View;
